import BlogPost from './BlogPost'

export default BlogPost;